export interface ImportTargetField {
    id: string;
    label: string;
    description: string;
    required: boolean;
}

export type ImportColumnMapping = Record<string, string[]>;

export const UNASSIGNED_COLUMN_ID = '__unassigned__';
export const IGNORE_COLUMN_ID = '__ignore__';

export interface FuzzyMatchImportColumnsInput {
    sourceColumns: string[];
    targetFields: Array<{ id: string; label: string }>;
}

export interface FuzzyMatchImportColumnsResponse {
    /** Target field id → ordered source column names. */
    mapping: Record<string, string[]>;
    unassigned: string[];
}

/**
 * Build a full ImportColumnMapping from the fuzzy-match API response.
 */
export function mappingFromFuzzyMatchResponse(
    response: FuzzyMatchImportColumnsResponse,
    targetFields: Array<{ id: string }>,
): ImportColumnMapping {
    const mapping: ImportColumnMapping = {
        [UNASSIGNED_COLUMN_ID]: [...(response.unassigned ?? [])],
        [IGNORE_COLUMN_ID]: [],
    };
    targetFields.forEach((f) => {
        mapping[f.id] = [...(response.mapping?.[f.id] ?? [])];
    });
    return mapping;
}

/**
 * Empty mapping with all sources in Unassigned.
 */
export function emptyColumnMapping(
    sourceColumns: string[],
    targetFields: Array<{ id: string }>,
): ImportColumnMapping {
    const mapping: ImportColumnMapping = {
        [UNASSIGNED_COLUMN_ID]: [...sourceColumns],
        [IGNORE_COLUMN_ID]: [],
    };
    targetFields.forEach((f) => {
        mapping[f.id] = [];
    });
    return mapping;
}
